import { Injectable } from '@angular/core';
import { S3ProductPublicService } from './s3-product-public.service';

@Injectable({ providedIn: 'root' })
export class S3SpcPublicService extends S3ProductPublicService {
  protected buildProbeImageUrl(month: string): string {
    return `${this.bucketBaseUrl}/${this.monthPrefix}${month}/persist_cat/persistencia_por_categoria_brasil_${month}_s1.png`;
  }
}
